<template>
  <div class="ClientInfo">
    <el-dialog
      :visible.sync="viewVisible"
      title="客户档案"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      custom-class="khgl-client-detail"
      :append-to-body="true">
      <div class="view-box" v-loading="viewLoading">
        <el-steps :active="clientDetail.mark===2&&clientDetail.groupid===4?2:clientDetail.mark===3?3:clientDetail.mark===9?4:1" simple>
          <el-step title="客户录入" icon="el-icon-edit-outline"></el-step>
          <el-step title="转意向" icon="el-icon-refresh"></el-step>
          <el-step title="合同签订" icon="el-icon-document-checked"></el-step>
          <el-step title="打款" icon="el-icon-coin"></el-step>
          <el-step title="建店" icon="el-icon-office-building"></el-step>
        </el-steps>
        <el-row style="margin-top: 20px">
          <el-col :span="8">
            <el-card class="base-info" shadow="never">
              <div slot="header" class="tit">
                <span>基本资料</span>
              </div>
              <div class="text">
                <div class="l">
                  <span class="label">客户姓名:</span>
                  <span class="name">{{clientDetail.name}}</span>
                  <svg-icon icon-class="client_man" class="client-sex" v-if="clientDetail.sex === 1"/>
                  <svg-icon icon-class="client_women" class="client-sex" v-if="clientDetail.sex === 0" />
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户等级:</span>
                  <el-rate style="float: left" v-model="clientDetail.level" disabled-void-color="#ffffff" disabled></el-rate>
                </div>
                <div class="l">
                  <span style="float: left" class="label">联系电话:</span>
                  <span>{{clientDetail.tel}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户微信:</span>
                  <span>{{clientDetail.wchat!==null&&clientDetail.wchat!==undefined&&clientDetail.wchat!==''?clientDetail.wchat:'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">所在地区:</span>
                  <span>{{clientDetail.province}} {{clientDetail.city}} {{clientDetail.county}}</span>
                </div>
                <el-alert v-if="clientDetail.areadealerlst.length<=0&&clientDetail.mark===2" title="该区域目前还未有代理经销商" type="success" :closable="false" style="margin-bottom: 15px" show-icon></el-alert>
                <el-popover
                  v-if="clientDetail.areadealerlst.length>0"
                  placement="right"
                  width="420"
                  :key="areaKey"
                  trigger="hover">
                  <el-table :data="clientDetail.areadealerlst">
                    <el-table-column width="120" property="allname" label="经销商" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" label="代理品牌" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span v-for="(b,index) in scope.row.brandlst">{{b.brandname}}{{index===scope.row.brandlst.length-1?'':'、'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="100" label="所在地区" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{scope.row.province}} {{scope.row.city}} {{scope.row.county}}
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-alert slot="reference" :title="`该区域目前已有${clientDetail.areadealerlst.length}个代理经销商`" type="warning" :closable="false" style="margin-bottom: 15px;cursor: pointer" show-icon></el-alert>
                </el-popover>
                <div class="l">
                  <span style="float: left" class="label">线下门店:</span>
                  <span>{{clientDetail.shop!==null&&clientDetail.shop!==undefined&&clientDetail.shop!==''?clientDetail.shop:'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">门店面积:</span>
                  <span>{{clientDetail.area!==null&&clientDetail.area!==undefined&&clientDetail.area!==''&&clientDetail.area>0?clientDetail.area+' m²':'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户来源:</span>
                  <span>{{clientDetail.source===1?'第三方平台':clientDetail.source===2?'招商会':clientDetail.source===3?'异业介绍':clientDetail.source===4?'地推':clientDetail.source===5?'商场推荐':clientDetail.source===6?'数字名片':'其他'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户状态:</span>
                  <el-tag type="danger" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle==1 && clientDetail.mark===2&& clientDetail.refund!==1">即将回收</el-tag>
                  <el-tag type="info" :disable-transitions="true" size="mini" v-if="clientDetail.mark===0&& clientDetail.refund!==1">置入死海</el-tag>
                  <el-tag type="danger" :disable-transitions="true" size="mini" v-if="clientDetail.mark===1&& clientDetail.refund!==1">回归公海</el-tag>
                  <el-tag type="warning" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle!=1 && clientDetail.mark===2 && clientDetail.groupid!=4&& clientDetail.refund!==1">待跟进</el-tag>
                  <el-tag type="success" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle!=1 && clientDetail.mark===2 && clientDetail.groupid==4&& clientDetail.refund!==1">已转意向</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&clientDetail.paymark===10&& clientDetail.refund!==1" class="tcf-tag-8">待打款</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&(clientDetail.paymark===0||clientDetail.paymark===1)&& clientDetail.refund!==1" class="tcf-tag-4">收款审核中</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&(clientDetail.paymark===3||clientDetail.paymark===4)&& clientDetail.refund!==1" type="danger">收款审核拒绝</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===9&& clientDetail.refund!==1">已完成</el-tag>
                  <el-tag size="mini" :disable-transitions="true" type="info" v-if="clientDetail.refund===1">已退款</el-tag>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户备注:</span>
                  <span>{{clientDetail.remark!==null&&clientDetail.remark!==undefined&&clientDetail.remark!==''?clientDetail.remark:'N/A'}}</span>
                </div>
              </div>
            </el-card>
            <el-card shadow="never" class="principal" v-if="clientDetail.followname!==null&&clientDetail.followname!==undefined&&clientDetail.followname!==''">
              <div slot="header" class="tit">
                <span>负责人</span>
              </div>
              <el-row>
                <el-col :span="14" class="user-info" style="line-height: 36px">
                  <el-avatar size="medium" :src="clientDetail.followphoto" style="float: left;margin-right: 10px"></el-avatar>
                  <span>{{clientDetail.followname}}</span>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="16" style="padding-left: 20px">
            <el-tabs v-model="activeViewName" :key="detailKey">
              <el-tab-pane label="跟进记录" name="gjjl"></el-tab-pane>
              <el-tab-pane label="转意向" name="yxj"></el-tab-pane>
              <el-tab-pane v-if="clientDetail.mark>=3" label="合同档案" name="htda"></el-tab-pane>
              <el-tab-pane v-if="clientDetail.mark===9" label="代理信息" name="dlxx"></el-tab-pane>
              <el-tab-pane v-if="clientDetail.mark===9" label="建店详情" name="jdxq"></el-tab-pane>
            </el-tabs>
            <div v-if="activeViewName === 'gjjl'">
              <div class="follow-list" v-loading="followLoading">
                <div class="follow-item" v-for="f in followList">
                  <div  class="follow-userinfo" v-if="f.username===null||f.username===undefined||f.username===''">
                    <el-avatar class="photo" shape="square" :size="50" :src="elichain_photo"></el-avatar>
                    <div class="name">慕鹿助手<el-tag size="mini" :type="f.type===0?'danger':f.way==='客户录入'?'':'warning'">{{f.way}}</el-tag></div>
                    <div class="time">{{f.time}}</div>
                  </div>
                  <div class="follow-userinfo" v-if="f.username!==null&&f.username!==undefined&&f.username!==''">
                    <el-avatar class="photo" shape="square" :size="50" :src="f.photourl"></el-avatar>
                    <div class="name">{{f.username}}<el-tag size="mini" :type="f.type===0?'danger':f.way==='客户录入'?'':'warning'">{{f.way}}</el-tag></div>
                    <div class="time">{{f.time}}</div>
                  </div>
                  <div class="follow-content" v-if="f.content!==null&&f.content!==undefined&&f.content!==''">{{f.content}}</div>
                  <div class="follow-imgs" v-if="f.imgurlarr.length>0">
                    <el-image
                      v-for="img in f.imgurlarr"
                      fit="cover"
                      class="follow-img"
                      :src="img"
                      :preview-src-list="f.imgurlarr"
                    />
                  </div>
                </div>
                <!--                <div class="follow-item">-->
                <!--                  <div class="follow-userinfo">-->
                <!--                    <el-avatar class="photo" shape="square" :size="50" :src="clientDetail.createphoto"></el-avatar>-->
                <!--                    <div class="name">{{clientDetail.createname}}<el-tag size="mini">客户录入</el-tag></div>-->
                <!--                    <div class="time">{{clientDetail.createtime}}</div>-->
                <!--                  </div>-->
                <!--                  <div class="follow-content">-->
                <!--                    由&nbsp;<span style="color: #409EFF">{{clientDetail.createdept}}-{{clientDetail.createname}}</span>&nbsp;录入此客户-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
            </div>
            <div v-if="activeViewName === 'yxj'">
              <el-card shadow="never" class="base-info" v-if="clientDetail.clientInmon!==null&&clientDetail.clientInmon!==undefined&&clientDetail.clientInmon!==''">
                <div slot="header" class="tit">
                  <span>意向金确认单</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">加盟地区:</span>
                    <span>{{clientDetail.clientInmon.province}} - {{clientDetail.clientInmon.city}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">意向品牌:</span>
                    <span><el-tag size="mini" :disable-transitions="true" style="margin-right: 10px" effect="plain">{{clientDetail.clientInmon.brandname}}</el-tag></span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">意向金额:</span>
                    <span>{{clientDetail.clientInmon.money}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款卡号:</span>
                    <span>{{clientDetail.clientInmon.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款日期:</span>
                    <span>{{clientDetail.clientInmon.receipttime}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">收款账户:</span>
                    <span>{{ clientDetail.clientInmon.accname }}（{{clientDetail.clientInmon.acccard}}）</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">享受权限:</span>
                    <span>{{clientDetail.clientInmon.enjoy!==null&&clientDetail.clientInmon.enjoy!==undefined&&clientDetail.clientInmon.enjoy!==''?clientDetail.clientInmon.enjoy:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">填写备注:</span>
                    <span>{{clientDetail.clientInmon.remark!==null&&clientDetail.clientInmon.remark!==undefined&&clientDetail.clientInmon.remark!==''?clientDetail.clientInmon.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款凭证:</span>
                    <el-image v-for="iurl in yxjpayImgs"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="yxjpayImgs">
                    </el-image>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" style="margin-top: 20px" class="base-info" v-if="clientDetail.yxjtk!==null">
                <div slot="header" class="tit">
                  <span>意向金退款</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">收款人:</span>
                    <span>{{clientDetail.yxjtk.name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">开户行:</span>
                    <span>{{clientDetail.yxjtk.bank}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款金额:</span>
                    <span>{{clientDetail.yxjtk.money}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">收款卡号:</span>
                    <span>{{clientDetail.yxjtk.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款原因:</span>
                    <span>{{clientDetail.yxjtk.refundrson!==null&&clientDetail.yxjtk.refundrson!==undefined&&clientDetail.yxjtk.refundrson!==''?clientDetail.yxjtk.refundrson:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款备注:</span>
                    <span>{{clientDetail.yxjtk.remark!==null&&clientDetail.yxjtk.remark!==undefined&&clientDetail.yxjtk.remark!==''?clientDetail.yxjtk.remark:'N/A'}}</span>
                  </div>
                </div>
              </el-card>
            </div>
            <div v-if="activeViewName === 'htda'">
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark>=3">
                <div slot="header" class="tit">
                  <span>合同信息</span>
                </div>
                <div class="text" v-loading="contractLoading">
                  <div class="l">
                    <span style="float: left" class="label">签订日期:</span>
                    <span>{{contract.time}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订地点:</span>
                    <span>{{contract.address}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订人员:</span>
                    <span>{{contract.username}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">客户全称:</span>
                    <span>{{contract.all_name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">展厅负责:</span>
                    <span>{{contract.group_name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订合同:</span>
                    <span>{{ contract.contarct_name }}（{{contract.contarct_code}}）</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">代理品牌:</span>
                    <span><el-tag v-for="b in contract.brandList" v-if="b.is_select==1" size="mini" :disable-transitions="true" style="margin-right: 10px" effect="plain">{{b.brand_name}}</el-tag></span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">合同备注:</span>
                    <span>{{contract.remark!==null&&contract.remark!==undefined&&contract.remark!==''?contract.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">合同原件:</span>
                    <el-image v-for="iurl in contractImg"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="contractImg">
                    </el-image>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark===9" style="margin-top: 20px">
                <div slot="header" class="tit">
                  <span>样品预存款确认单</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">申请人员:</span>
                    <span>{{clientDetail.payinfo.username}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">申请时间:</span>
                    <span>{{clientDetail.payinfo.time}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">招商总监:</span>
                    <span>{{clientDetail.payinfo.dirname}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核时间:</span>
                    <span>{{clientDetail.payinfo.dirtime}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核人员:</span>
                    <span>{{clientDetail.payinfo.auditname}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核时间:</span>
                    <span>{{clientDetail.payinfo.audittime}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">店面形式:</span>
                    <span>{{clientDetail.payinfo.shopform===0?'商场内店':clientDetail.payinfo.shopform===1?'店中店':clientDetail.payinfo.shopform===2?'沿街店':'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">总面积:</span>
                    <span>{{clientDetail.payinfo.totalarea}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">品牌占用面积:</span>
                    <span>{{clientDetail.payinfo.area}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">门店地址:</span>
                    <span>{{clientDetail.province}}{{clientDetail.city}}{{clientDetail.county}}{{clientDetail.payinfo.address}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款账户:</span>
                    <span>{{clientDetail.payinfo.accountname}}（{{clientDetail.payinfo.accountcard}}）</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款日期:</span>
                    <span>{{clientDetail.payinfo.receipttime}}</span>
                  </div>
                  <div class="l">
                    <span class="label">打款金额:</span>
                    <span>{{clientDetail.payinfo.money}}元</span>
                    <span class="label" style="margin-left: 20px">样品预存款:</span>
                    <span>{{ clientDetail.payinfo.join}}元</span>
                    <span class="label" style="margin-left: 20px">加盟费:</span>
                    <span>{{ clientDetail.payinfo.insure}}元</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款卡号:</span>
                    <span>{{ clientDetail.payinfo.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款备注:</span>
                    <span>{{clientDetail.payinfo.remark!==null&&clientDetail.payinfo.remark!==undefined&&clientDetail.payinfo.remark!==''?clientDetail.payinfo.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款凭证:</span>
                    <el-image v-for="iurl in clientDetail.payinfo.payImgs"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="clientDetail.payinfo.payImgs">
                    </el-image>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" style="margin-top: 20px" class="base-info" v-if="(clientDetail.jmjtk!==null&&clientDetail.mark===9)||clientDetail.mark===7">
                <div slot="header" class="tit">
                  <span>样品预存款退款</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">收款人:</span>
                    <span>{{clientDetail.jmjtk.name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">开户行:</span>
                    <span>{{clientDetail.jmjtk.bank}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款金额:</span>
                    <span>{{clientDetail.jmjtk.money}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">收款卡号:</span>
                    <span>{{clientDetail.jmjtk.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款原因:</span>
                    <span>{{clientDetail.jmjtk.refundrson!==null&&clientDetail.jmjtk.refundrson!==undefined&&clientDetail.jmjtk.refundrson!==''?clientDetail.jmjtk.refundrson:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款备注:</span>
                    <span>{{clientDetail.jmjtk.remark!==null&&clientDetail.jmjtk.remark!==undefined&&clientDetail.jmjtk.remark!==''?clientDetail.jmjtk.remark:'N/A'}}</span>
                  </div>
                </div>
              </el-card>
            </div>
            <div v-if="activeViewName === 'dlxx'">
              <el-row :gutter="12">
                <el-col :span="8" v-for="item in clientDetail.brandinfo">
                  <el-card shadow="hover" class="brand-info">
                    <div class="main-info">
                      <el-image
                        style="width: 100%; height: 60px"
                        :src="item.brandlogo"
                        fit="contain"></el-image>
                    </div>
                    <div class="more-info">
                      <div class="info-row">
                        <span class="title">{{item.brandname}}</span>
                      </div>
                      <div class="info-row info-content">
                        <p><span>区域经理：</span>{{item.areaname!==null&&item.areaname!==undefined&&item.areaname!==''?item.areaname:'未分配'}}</p>
                        <p><span>销售客服：</span>{{item.servicename!==null&&item.servicename!==undefined&&item.servicename!==''?item.servicename:'未分配'}}</p>
                        <p><span>报价专员：</span>{{item.offername!==null&&item.offername!==undefined&&item.offername!==''?item.offername:'未分配'}}</p>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div v-if="activeViewName === 'jdxq'" class="project-info" v-loading="overviewLoading">
              <el-alert
                v-if="clientDetail.project===null||clientDetail.project===undefined||clientDetail.project===NaN"
                title="此经销商建店事项还未立项"
                type="warning"
                :closable="false"
                show-icon>
              </el-alert>
              <el-row v-if="clientDetail.project!==null&&clientDetail.project!==undefined&&clientDetail.project!==NaN">
                <el-col :span="14">
                  <div class="overview-box">
                    <div :class="overviewChange===0?'overview-item active':'overview-item'" @click="setOverviewChange(0)">
                      <span>总数</span>
                      <div class="num">{{overviewNum.zs}}</div>
                      <el-progress :percentage="100" color="#3DA8F5" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===1?'overview-item active':'overview-item'" @click="setOverviewChange(1)">
                      <span>已完成</span>
                      <div class="num">{{overviewNum.ywc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.ywc/overviewNum.zs*100:0" color="#9ED979" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===2?'overview-item active':'overview-item'" @click="setOverviewChange(2)">
                      <span>未完成</span>
                      <div class="num">{{overviewNum.wwc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.wwc/overviewNum.zs*100:0" color="#FF8479" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===3?'overview-item active':'overview-item'" @click="setOverviewChange(3)">
                      <span>已逾期</span>
                      <div class="num">{{overviewNum.yyq}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.yyq/overviewNum.zs*100:0" color="#FF9F00" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===4?'overview-item active':'overview-item'" @click="setOverviewChange(4)">
                      <span>待认领</span>
                      <div class="num">{{overviewNum.drl}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.drl/overviewNum.zs*100:0" color="#A1A4D9" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===5?'overview-item active':'overview-item'" @click="setOverviewChange(5)">
                      <span>时间待定</span>
                      <div class="num">{{overviewNum.sjdd}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.sjdd/overviewNum.zs*100:0" color="#9ED979" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===6?'overview-item active':'overview-item'" @click="setOverviewChange(6)">
                      <span>今日到期</span>
                      <div class="num">{{overviewNum.jrdq}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.jrdq/overviewNum.zs*100:0" color="#FFC774" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===7?'overview-item active':'overview-item'" @click="setOverviewChange(7)">
                      <span>逾期完成</span>
                      <div class="num">{{overviewNum.yqwc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.yqwc/overviewNum.zs*100:0" color="#FF8478" :show-text="false"></el-progress>
                    </div>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="info-box">
                    <el-progress type="circle" class="percent" :width="70" :percentage="projectPercent"></el-progress>
                    <div class="name"><el-button @click="goProjectDetail" type="text" icon="el-icon-document" size="mini" style="font-size: 16px;padding: 0">{{clientDetail.project.name}}</el-button></div>
                    <div class="time">{{clientDetail.project.username}}于 {{dateToWz(clientDetail.project.time)}} 创建</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-document"></i><span>项目说明</span></div>
                    <div class="txt">{{clientDetail.project.explain!==null&&clientDetail.project.explain!==''&&clientDetail.project.explain!==undefined?clientDetail.project.explain:'未填写'}}</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-date"></i><span>项目周期</span></div>
                    <div class="txt">{{dateToWz(clientDetail.project.startdate)}} - {{dateToWz(clientDetail.project.enddate)}}</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-finished"></i><span>项目状态</span></div>
                    <div class="txt">
                      <el-tag v-if="clientDetail.project.mark===0" type="danger" :disable-transitions="true" size="mini">未开始</el-tag>
                      <el-tag v-if="clientDetail.project.mark===1" type="success" :disable-transitions="true" size="mini">进行中</el-tag>
                      <el-tag v-if="clientDetail.project.mark===2" type="warning" :disable-transitions="true" size="mini">已暂停</el-tag>
                      <el-tag v-if="clientDetail.project.mark===3" :disable-transitions="true" size="mini">已完成</el-tag>
                      <el-tag v-if="clientDetail.project.mark===4" type="info" :disable-transitions="true" size="mini">已取消</el-tag>
                    </div>
                  </div>
                </el-col>
                <el-col :span="24" style="padding-top: 20px">
                  <el-table
                    :data="overviewData"
                    border
                    style="width: 100%">
                    <el-table-column
                      type="index"
                      align="center"
                      width="50">
                    </el-table-column>
                    <el-table-column
                      label="计划周期"
                      width="220">
                      <template slot-scope="scope">
                        <span v-if="scope.row.startdate!==null&&scope.row.startdate!==undefined&&scope.row.startdate!==''&&scope.row.enddate!==null&&scope.row.enddate!==undefined&&scope.row.enddate!==''">{{dateToWz(scope.row.startdate)}}-{{dateToWz(scope.row.enddate)}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="taskname"
                      label="事项"
                      width="140">
                    </el-table-column>
                    <el-table-column
                      prop="username"
                      label="执行人"
                      width="80">
                    </el-table-column>
                    <el-table-column
                      label="当前阶段"
                      width="120">
                      <template slot-scope="scope">
                        <span>{{scope.row.stagename}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="当前进度"
                      width="100">
                      <template slot-scope="scope">
                        {{scope.row.psid===0?100:scope.row.percent}}%
                      </template>
                    </el-table-column>
                    <!--                    <el-table-column-->
                    <!--                      label="优先级"-->
                    <!--                      width="120">-->
                    <!--                      <template slot-scope="scope">-->
                    <!--                        <el-tag :type="scope.row.priority===1?'':scope.row.priority===2?'warning':scope.row.priority===3?'danger':'info'" size="small" effect="plain">{{scope.row.priority===1?'普通':scope.row.priority===2?'紧急':scope.row.priority===3?'非常紧急':'较低'}}</el-tag>-->
                    <!--                      </template>-->
                    <!--                    </el-table-column>-->
                    <el-table-column
                      prop="stagename"
                      label="实际工期"
                      min-width="220">
                      <template slot-scope="scope">
                        <span v-if="scope.row.startdateReal!==null&&scope.row.startdateReal!==undefined&&scope.row.startdateReal!==''&&scope.row.enddateReal!==null&&scope.row.enddateReal!==undefined&&scope.row.enddateReal!==''">{{dateToWz(scope.row.startdateReal)}}-{{dateToWz(scope.row.enddateReal)}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getClentFollowList, getClientDetail, getProjectTaskListByPid, getSignedContract } from '@/api/work'
import { formatDate } from '@/api/pub'
import elichain_photo from '@/assets/elichain_photo.jpg'

export default {
  name: 'ClientInfo',
  computed: {
    user: getUser
  },
  data() {
    return {
      elichain_photo: elichain_photo,
      activeViewName: 'gjjl',
      clientDetail: {
        areadealerlst: [],
        project: {}
      },
      viewVisible: false,
      viewLoading: false,
      areaKey: '',
      forwardKey: '',
      detailKey: '',
      followList: [],
      followLoading: false,
      contractLoading: false,
      contract: {},
      contractImg: [],
      overviewLoading: false,
      overviewBaseData: [],
      overviewData: [],
      projectPercent: 0,
      overviewNum: {
        zs: 0,
        ywc: 0,
        wwc: 0,
        yyq: 0,
        drl: 0,
        sjdd: 0,
        jrdq: 0,
        yqwc: 0
      },
      overviewChange: 0
    }
  },
  methods: {
    openClientDetails(cid) {
      this.areaKey = new Date().getTime()
      this.forwardKey = this.areaKey + 1
      this.detailKey = this.areaKey + 2
      this.activeViewName = 'gjjl'
      this.followList = []
      this.viewVisible = true
      this.viewLoading = true
      const data = {
        userid: this.user.dUserid,
        clientid: cid,
        groupid: this.user.dGroupid
      }
      getClientDetail(data).then(response => {
        this.clientDetail = response.data
        this.clientDetail.createtime = formatDate(Date.parse(this.clientDetail.createtime))
        if (this.clientDetail.mark === 9) {
          let _payImgs = []
          for (let img of this.clientDetail.payinfo.imglst) {
            _payImgs.push(img.imgurl)
          }
          this.clientDetail.payinfo.payImgs = _payImgs
        }
        this.viewLoading = false
        this.getFollowList()
        if (this.clientDetail.mark >= 3) {
          this.getContractDetail()
        }
        let _clientInmon = this.clientDetail.clientInmon
        if (_clientInmon !== null && _clientInmon !== undefined) {
          let _yxjpayImgs = []
          for (let img of _clientInmon.clientInmonImgList) {
            _yxjpayImgs.push(img.imgurl)
          }
          this.yxjpayImgs = _yxjpayImgs
        }
        if (this.clientDetail.mark === 9) {
          if (this.clientDetail.project !== null && this.clientDetail.project !== undefined && this.clientDetail.project !== NaN) {
            this.getProjectTask()
          }
        }
      }).catch(() => {
        this.viewLoading = false
      })
    },
    getFollowList() {
      this.followLoading = true
      getClentFollowList({ cid: this.clientDetail.cid }).then(response => {
        this.followLoading = false
        let _followList = response.data
        for (let t of _followList) {
          let _imgurlarr = []
          t.time = formatDate(Date.parse(t.time))
          for (const i of t.imglst) {
            _imgurlarr.push(i.imgurl)
          }
          t.imgurlarr = _imgurlarr
        }
        this.followList = _followList
      }).catch(() => {
        this.followLoading = false
      })
    },
    getContractDetail() {
      this.contract = {}
      this.contractImg = []
      this.contractLoading = true
      getSignedContract({ signid: this.clientDetail.cid }).then(response => {
        this.contract = response.data
        this.contractLoading = false
        let imgs = []
        for (let c of this.contract.imgList) {
          imgs.push(c.img_url)
        }
        this.contractImg = imgs
      }).catch(() => {
        this.contractLoading = false
      })
    },
    getProjectTask() {
      this.overviewLoading = true
      getProjectTaskListByPid({ pid: this.clientDetail.project.pid }).then(response => {
        this.overviewBaseData = response.data
        let _ywc = 0, _wwc = 0, _yyq = 0, _drl = 0, _sjdd = 0, _jrdq = 0, _yqwc = 0
        const newDate = new Date()
        const today = `${newDate.getFullYear()}-${newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
        let unp = 0.0
        let _projectPercent = 0.0
        if (response.data.length > 0) {
          unp = 100 / response.data.length
        }
        for (const t of response.data) {
          if (t.psid === 0) {
            _projectPercent = _projectPercent + unp
            _ywc++
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== undefined && t.enddateReal !== null && t.enddateReal !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _yqwc++
                }
              }
            }
          } else {
            if (t.percent > 0) {
              _projectPercent = _projectPercent + (t.percent / 100 * unp)
            }
            _wwc++
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate === today) {
                _jrdq++
              } else {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(today)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _yyq++
                }
              }
            }
          }
          if (t.userid === 0 || t.userid === null || t.userid === undefined) {
            _drl++
          }
          if (t.enddate === null || t.enddate === undefined || t.enddate === '') {
            _sjdd++
          }
        }
        this.projectPercent = Math.floor(_projectPercent)
        this.overviewNum = {
          zs: response.data.length,
          ywc: _ywc,
          wwc: _wwc,
          yyq: _yyq,
          drl: _drl,
          sjdd: _sjdd,
          jrdq: _jrdq,
          yqwc: _yqwc
        }
        this.filterOverviewData()
        this.overviewLoading = false
      })
    },
    filterOverviewData() {
      let _overviewData = []
      const newDate = new Date()
      const today = `${newDate.getFullYear()}-${newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
      for (const t of this.overviewBaseData) {
        if (this.overviewChange === 0) {
          _overviewData.push(t)
        } else if (this.overviewChange === 1) {
          if (t.psid === 0) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 2) {
          if (t.psid !== 0) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 3) {
          if (t.psid !== 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(today)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _overviewData.push(t)
                }
              }
            }
          }
        } else if (this.overviewChange === 4) {
          if (t.userid === 0 || t.userid === null || t.userid === undefined) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 5) {
          if (t.enddate === null || t.enddate === undefined || t.enddate === '') {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 6) {
          if (t.psid !== 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate === today) {
                _overviewData.push(t)
              }
            }
          }
        } else if (this.overviewChange === 7) {
          if (t.psid === 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== undefined && t.enddateReal !== null && t.enddateReal !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _overviewData.push(t)
                }
              }
            }
          }
        }
      }
      this.overviewData = _overviewData
    },
    setOverviewChange(n) {
      this.overviewChange = n
      this.filterOverviewData()
    },
    goProjectDetail() {
      this.viewVisible = false
      this.$router.push({ path: '/work/project_detail/' + this.clientDetail.project.pid })
    },
    dateToWz(d) {
      if (d !== null && d !== undefined) {
        if (d.length > 10) {
          d = d.substring(0, 10)
        }
        const darr = d.split('-')
        return darr[0] + '年' + darr[1] + '月' + darr[2] + '日'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.view-box{
  width: 100%;
  position: relative;
  .base-info{
    width: 100%;
    position: relative;
    .tit{
      width: 100%;
      position: relative;
      span{
        font-weight: 500;
      }
    }
    .text{
      font-size: 13px;
      .l{
        margin-bottom: 15px;
        .label{
          color: #828792;
          margin-right: 14px;
        }
        .name{
          font-weight: 500;
          font-size: 14px;
        }
        .client-sex{
          width: 18px!important;
          height: 18px!important;
          vertical-align: -4px!important;
        }
        &:last-child{
          margin-bottom: 0;
        }
        &:after{
          content: ' ';
          display: table;
          clear: both;
        }
      }
    }
    .user-info{
      width: 100%;
      position: relative;
      padding-left: 60px;
      margin-bottom: 20px;
      .photo{
        position: absolute;
        top: 0;
        left: 0;
      }
      .name{
        font-size: 14px;
        font-weight: 500;
        padding-top: 4px;
        .client-sex{
          width: 18px!important;
          height: 18px!important;
          vertical-align: -4px!important;
        }
      }
      .dept{
        padding-top: 6px;
        font-size: 12px;
        color: #999999;
      }
    }
    .count-box{
      width: 100%;
      position: relative;
      margin-bottom: 20px;
      background-color: #f4f4f5;
      border-radius: 4px;
      padding: 10px 0;
      &:after{
        content: ' ';
        display: table;
        clear: both;
      }
      .count-item{
        float: left;
        width: 33.33%;
        text-align: center;
        .num{
          font-size: 15px;
          font-weight: 500;
        }
        .txt{
          font-size: 12px;
          color: #828792;
        }
      }
    }
  }
  .principal{
    width: 100%;
    position: relative;
    margin-top: 20px;
    .tit{
      width: 100%;
      position: relative;
      span{
        font-weight: 500;
      }
    }
  }
  .follow-from{
    width: 100%;
    position: relative;
    border: 1px solid #EBEEF5;
    margin-bottom: 10px;
    border-radius: 4px;
    padding-bottom: 10px;
    .follow-img-box{
      width: 100%;
      position: relative;
      padding: 5px 15px;
    }
    .btn-box{
      border-bottom: 1px solid #EBEEF5;
      width: 100%;
      height: 40px;
      line-height: 40px;
      position: relative;
      padding: 0 15px;
    }
  }
  .follow-list{
    width: 100%;
    position: relative;
    .edit-btn{
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 1;
    }
    .follow-item{
      width: 100%;
      position: relative;
      border: 1px solid #EBEEF5;
      margin-bottom: 20px;
      border-radius: 4px;
      padding: 15px;
      .follow-userinfo{
        width: 100%;
        position: relative;
        padding-left: 60px;
        .photo{
          position: absolute;
          top: 0;
          left: 0;
        }
        .name{
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 4px;
          padding-top: 4px;
          span{
            font-size: 12px;
            margin-left: 10px;
          }
        }
        .time{
          font-size: 12px;
          color:#999;
        }
      }
      .follow-content{
        padding-top: 15px;
        font-size: 13px;
      }
      .follow-imgs{
        width: 100%;
        position: relative;
        margin-top: 10px;
        .follow-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
  }
  .brand-info{
    margin:6px 0;
    .main-info{
      border-bottom: 1px solid #eee;
      position: relative;
      text-align: center;
    }
    .more-info{
      margin-top: 8px;
      .info-row{
        font-size: 12px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: center;
        .title {
          font-size: 16px;
        }
        p {
          margin: 4px 0 !important;
          span{
            color:#99a9bf;
          }
        }
      }
    }
  }
  .client-list{
    width: 100%;
    position: relative;
    &:after{
      content: ' ';
      display: table;
      clear: both;
    }
    .client-item{
      width: 247px;
      float: left;
      margin-bottom: 17px;
      margin-right: 17px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      overflow: hidden;
      color: #303133;
      position: relative;
      cursor: pointer;
      padding: 5px 15px;
      transition: .3s;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
      }
      .name{
        padding: 10px 0;
        span{
          font-size: 14px;
          font-weight: 500;
        }
        .client-sex{
          width: 18px!important;
          height: 18px!important;
          vertical-align: -4px!important;
        }
        .mark{
          float: right;
          .el-dropdown-link{
            color: #828792;
          }
        }
      }
      .info-box{
        width: 100%;
        position: relative;
        height: 36px;
        line-height: 36px;
        .label{
          width: 55px;
          color: #828792;
          float: left;
        }
        .txt{
          width: 160px;
          float: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
